<template>
  <div class="app-header">
    <b-modal
      v-if="isWalletConnected"
      id="sponsor-modal"
      size="xl"
      hide-header
      hide-footer
    >
      <div class="affiliate-modal">
        <button class="close-button" @click="$bvModal.hide('sponsor-modal')">
          <img
            class="close-button-image"
            src="../assets/affiliate_close_button.png"
          />
        </button>
        <p class="sponsor-main-title">Grow Your Affiliate Network & Earn</p>
        <img
          class="zoombies-logo"
          src="https://zoombies.world/images/zoombies_coin.svg"
        />
        <p
          v-if="queryHasSponsor && !showShareMyLink"
          class="sponsor-description"
        >
          Zoombies World will reward sponsors who have been associated to an
          affiliate. You may only have 1 sponsor, but you may have any number of
          affiliates. Each time one of your linked affiliates generates ZOOM
          during game play,
          <span style="color: #00d1ff"
            >you will receive a 20% ZOOMBIE token reward</span
          >
          as their sponsor!
        </p>
        <p v-else class="sponsor-description">
          Zoombies World will reward sponsors who have been associated to an
          affiliate. You may only have 1 sponsor, but you may have any number of
          affiliates. Each time one of your linked affiliates generates ZOOM
          during game play,
          <span style="color: #00d1ff"
            >you will receive a 20% ZOOMBIE token reward</span
          >
          as their sponsor!
          <span style="color: #dc78ff"
            >Receive a FREE PLATINUM NFT CARD for linking your sponsor
            below!</span
          >
        </p>
        <b-jumbotron class="jumbo" style="background-color: transparent">
          <p
            v-if="queryHasSponsor && !showShareMyLink"
            class="sponsor-link-description-title-2"
          >
            <span class="sponsor-link-description-text">
              Receieve a FREE PLATINUM NFT CARD for linking your sponsor below!
            </span>
            {{ sponsorTitle }}:
          </p>
          <p v-else class="sponsor-link-description-title">
            {{ sponsorTitle }}:
          </p>
          <p class="sponsor-link-description">
            By linking your sponsor's wallet address, you will mint a
            <span style="color: #dc78ff">
              Free Platinum Sponsored NFT Card immediately!
            </span>
            <span style="color: #ff0a54">
              Note: You can only link sponsor once. This affiliation is
              permanent and cannot be unmade.
            </span>
          </p>
          <b-input-group
            v-if="shouldShowSponsor"
            class="sponsor-address-input"
            size="lg"
          >
            <b-form-input
              v-model="sponsorAddress"
              :state="isSponsorValid"
              required
              type="text"
              placeholder="Enter Address"
            />
            <b-input-group-append>
              <b-button
                variant="success"
                :disabled="!isSponsorValid || sponsorAddress === ''"
                @click="linkSponsor"
              >
                Link
              </b-button>
            </b-input-group-append>
            <div v-if="sponsorAddress !== ''">
              <b-form-invalid-feedback v-if="!isSponsorValid">
                <div>Please enter a valid address.</div>
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="isSameSponsor">
                <div>You can't link your own wallet.</div>
              </b-form-invalid-feedback>
            </div>
          </b-input-group>
          <b-alert v-else variant="success" show>
            You are already linked to sponsor wallet.
          </b-alert>
        </b-jumbotron>

        <div v-if="queryHasSponsor && !showShareMyLink" class="platinum-card">
          <div class="platinum-card-wrapper">
            <img
              class="platinum-card-image"
              src="../assets/affiliate_platinum_card.png"
            />
          </div>
        </div>

        <div v-if="queryHasSponsor && !showShareMyLink" class="close-button">
          <b-button
            variant="danger"
            class="affiliate-button-2"
            @click="$bvModal.hide('sponsor-modal')"
          >
            Close
          </b-button>
        </div>

        <b-jumbotron
          v-else
          id="sponsor-link-wrapper"
          class="jumbo"
          style="background-color: transparent"
        >
          <p class="sponsor-link-text-title">Your Affiliate Link</p>
          <p class="sponsor-link-text">
            Automatically earn ZOOM
            <img
              class="czxp-logo"
              src="@/assets/zoomTokenCoin.svg"
              alt="zoom coin"
              align="middle"
            />
            Token rewards from your affiliate network. Copy and share or tweet
            your link to your friends so they can mint a
            <span style="color: #dc78ff">
              Free Platinum Sponsored Card and begin earning ZOOM for you today!
            </span>
          </p>
          <input
            id="sponsor-link"
            ref="sponsor"
            hidden
            :value="getSponsorRoute"
          />
          <div class="button-wrapper">
            <!-- <a :href="getTweet" data-size="large">
              <b-button variant="primary" class="affiliate-button"
                ><img
                  style="width: 30px"
                  src="https://utilitypeopleuk.com/wp-content/uploads/2017/06/twitter-icon-circle-blue-logo-preview.png"
                />
                Tweet your link</b-button
              >
            </a> -->
            <a class="socials-holder" :href="getTweet" target="_blank">
              <b-icon-twitter class="new-social-icons"></b-icon-twitter>
            </a>
            <a class="socials-holder" :href="getFacebookLink" target="_blank">
              <b-icon-facebook class="new-social-icons"></b-icon-facebook>
            </a>
            <a class="socials-holder" :href="getLinkedInLink" target="_blank">
              <b-icon-linkedin class="new-social-icons"></b-icon-linkedin>
            </a>
            <a class="socials-holder" @click="emailHandler">
              <b-icon-envelope class="new-social-icons"></b-icon-envelope>
            </a>
            <a class="socials-holder" :href="getWhatsAppLink" target="_blank">
              <b-icon-whatsapp class="new-social-icons"></b-icon-whatsapp>
            </a>
            <a id="social-link-popover" class="socials-holder" :href="getTelegramLink" target="_blank">
              <b-icon-telegram class="new-social-icons"></b-icon-telegram>
            </a>
            <a class="socials-holder" @click="$bvModal.show('qr-modal')">
              <b-icon-upc-scan class="new-social-icons"></b-icon-upc-scan>
            </a>
            <b-button id="copy-link-popover" class="affiliate-button" @click="copySponsorLink">
              Copy Link To Clipboard
            </b-button>
            <!-- <div class="telegram-link">
              <script
                async
                type="application/javascript"
                src="https://telegram.org/js/telegram-widget.js?15"
                :data-telegram-share-url="getTelegramLink"
                data-comment="Click my Zoombies Moonriver sponsor link to claim your Free Platinum NFT now!"
                data-size="large"
              ></script>
            </div> -->
          </div>
          <img
            class="zoombies-image"
            src="../assets/affiliate_modal_image.png"
          />
        </b-jumbotron>

        <div v-if="queryHasSponsor" class="prev-next-buttons">
          <b-button
            :style="{ visibility: showShareMyLink ? 'visible' : 'hidden' }"
            size="lg"
            variant="link"
            @click="previousSponsorModalAction"
            >Previous</b-button
          >
          <b-button
            :style="{ visibility: showShareMyLink ? 'hidden' : 'visible' }"
            size="lg"
            variant="link"
            @click="nextSponsorModalAction"
            >Skip</b-button
          >
        </div>
      </div>
    </b-modal>

    <b-modal
      id="qr-modal"
      hide-footer
      hide-header
    >
      <div class="qr-modal-container" @click="$bvModal.hide('qr-modal')">
        <div class="qr-code-text">
          Scan QR Code to claim Your Free Platinum Zoombies NFT Now!
        </div>
        <div class="qr-code-div">
          <qrcode-vue :value="getSponsorRoute" size="300" level="H" />
        </div>
      </div>
    </b-modal>

    <b-modal id="network-modal" hide-footer hide-header centered>
      <div class="network-close-button" @click="$bvModal.hide('network-modal')">
        Close
      </div>
      <div class="network-modal">
        <h1 class="network-modal-title">Select a network</h1>
        <div class="network-switch-btn-container">
          <button class="network-links" @click="moonbeamConnector">
            <img
              src="../assets/moonbeam_logo.png"
              alt="Moonbeam Logo"
              class="network-icons"
            />
            <p>Moonbeam</p>
          </button>
          <button class="network-links" @click="moonriverConnector">
            <img
              src="../assets/movr_logo.png"
              alt="Moonbeam Logo"
              class="network-icons"
            />
            <p>Moonriver</p>
          </button>
          <button class="network-links" @click="moonbaseConnector">
            <img
              src="https://zoombies.world/images/moonbase.png"
              alt="Moonbase Alpha Logo"
              class="network-icons"
            />
            <p>Moonbase(test)</p>
          </button>
          <button class="network-links" @click="zetaConnector">
            <img
              src="../assets/zetachain-icon.png"
              alt="ZetaChain Logo"
              class="network-icons"
            />
            <p>ZetaChain(test)</p>
          </button>          
        </div>
      </div>
    </b-modal>
    <div class="app-menu-bar">
      <router-link
            class="header-item aqua-header"
            :to="{ name: 'BodyContent', params: { chain: currentChain } }"
          >
        <img
          id="zoombie-logo-popover"
          class="zoombie-logo"
          alt="Zoombies World Logo"
          src="../assets/zoombies_logo_horizontal_white_text_only.png"
        />
      </router-link>
      <ul class="app-menu-bar-items">
        <li>
          <button
            id="earn-zoom-popover"
            v-b-modal.sponsor-modal
            class="header-item affiliate-header"
            aria-label="Open affiliate modal"
          >
            Earn Free Zoom
          </button>
        </li>
        <li>
          <router-link
            class="header-item aqua-header"
            :to="{ name: 'ShopContent', params: { chain: currentChain } }"
          >
            Shop
          </router-link>
        </li>
        <li>
          <router-link
            class="header-item aqua-header"
            :to="{ name: 'CryptContent', params: { chain: currentChain } }"
          >
            Your NFT Crypt
          </router-link>
        </li>
        <b-dropdown right class="dropdown-container">
          <b-dropdown-item>
            <router-link
              class="header-item-drop"
              :to="{ name: 'MarketContent', params: { chain: currentChain } }"
            >
              Markets
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link
              class="header-item-drop"
              :to="{
                name: 'TokenContent',
                params: { chain: currentChain, token_id: '1' },
              }"
            >
              Card Valuation
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link
              class="header-item-drop"
              :to="{ name: 'CardSets', params: { chain: currentChain } }"
            >
              Card Sets
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link
              class="header-item-drop"
              :to="{ name: 'AffiliateDashboard', params: { chain: currentChain } }"
            >
              Affiliates
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link
              class="header-item-drop"
              :to="{ name: 'DataIndicators', params: { chain: currentChain } }"
            >
              Data
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item href="https://www.zoombies.info/" target="_blank">
            <div class="header-item-drop">About Zoombies</div>
          </b-dropdown-item>
          <b-dropdown-item
            href="https://zoombies.gitbook.io/zoombies/"
            target="_blank"
          >
            <div class="header-item-drop">Help</div>
          </b-dropdown-item>
        </b-dropdown>
        <div class="header-right-container">
          <div v-if="isWalletConnected" class="balances-header">
            <div v-b-tooltip.hover.bottom :title="getZoomBalance">
              <img id="zoom-icon-popover" src="../../assets/zoomTokenCoin.svg" class="header-icon"/>
              <span>
                {{ getZoomBalance.toLocaleString() }}
              </span>
            </div>
            <div v-b-tooltip.hover.bottom :title="getBalance">
              <img
                v-if="isGlmr"
                id="header-icon-popover"
                src="../assets/moonbeam_logo.png"
                class="header-icon"
              />
              <img v-else id="header-icon-popover" src="../assets/moonbase.png" class="header-icon" />
              <span
                >{{
                  isGlmr
                    ? getBalance.toFixed(4)
                    : getBalance.toFixed(3) + `${isGlmr ? " GLMR" : " DEV"}`
                }}
              </span>
            </div>
          </div>
          <div v-if="isWalletConnected" class="address-header">
            <a id="vip-icon-popover" href="https://www.zoombies.info/vip"
              @mouseover="vipIconHoverPopover = true"
              @mouseleave="vipIconHoverPopover = false"
              ><div>
                <img
                  v-if="getVipLevel == 1"
                  src="https://zoombies.world/images/silver_vip.png"
                  class="header-icon-vip"
                />
                <img
                  v-else-if="getVipLevel == 2"
                  src="https://zoombies.world/images/gold_vip.png"
                  class="header-icon-vip"
                />
                <img
                  v-else-if="getVipLevel == 3"
                  src="https://zoombies.world/images/diamond_vip.png"
                  class="header-icon-vip"
                />
                <img
                  v-else
                  src="https://zoombies.world/images/novip.png"
                  class="header-icon-vip"
                /></div>
              </a>
            <span
              id="address-popover" 
              v-b-tooltip.hover.bottom
              :title="getWalletAddress"
            >
              &nbsp;{{
                getWalletAddress.substr(0, 6) +
                "..." +
                getWalletAddress.substr(38)
              }}
            </span>
          </div>
          <div v-if="isWalletConnected" id="claim-bonus-button" class="desktop-bonus">
            <div
              v-if="bonusReady && showSpinner == false"
              class="bonusClass"
              @click="GetBonus"
            >
              Claim 1 FREE Booster!
            </div>
            <div v-else-if="showSpinner == true">
              <b-spinner
                style="width: 1.5rem; height: 1.5rem"
                type="grow"
                variant="light"
              />
              <transition>
                <span class="spinner-text-style">
                  {{ transactionMessage }}</span
                >
              </transition>
            </div>
            <div
              v-else-if="!bonusReady && timeToBonus && showSpinner == false"
              class="bonusClassNo"
            >
              <span>Your Next Bonus: </span>
              <strong class="time-to-bonus">{{ timeToBonus }}</strong>
            </div>
          </div>
          <b-button
            v-if="!isWalletConnected && !isDesktopNotConnected"
            v-b-toggle.nav-collapse
            variant="warning"
            class="desktop-connect-btn"
            @click="reloadPage()"
          >
            Connect
          </b-button>
        </div>
      </ul>
      <div class="mobile-bonus">
        <div
          v-if="isWalletConnected && bonusReady && showSpinner == false"
          class="bonusClass"
          @click="GetBonus"
        >
          Claim 1 FREE Booster!
        </div>
        <div v-else-if="isWalletConnected && showSpinner == true">
          <b-spinner
            style="width: 1.5rem; height: 1.5rem"
            type="grow"
            variant="light"
          />
          <transition>
            <span class="spinner-text-style"> {{ transactionMessage }}</span>
          </transition>
        </div>
        <div
          v-else-if="
            isWalletConnected &&
            !bonusReady &&
            timeToBonus &&
            showSpinner == false
          "
          class="bonusClassNo"
        >
          <span>Your Next Bonus: </span>
          <strong class="time-to-bonus">{{ timeToBonus }}</strong>
        </div>
        <b-button
          v-if="!isWalletConnected && !isMobileNotConnected"
          v-b-toggle.nav-collapse
          variant="warning"
          class="mobile-connect-btn"
          @click="$emit('connect')"
        >
          Connect
        </b-button>
      </div>
      <div
        aria-label="hamburger menu"
        class="hamburger-menu"
        @click="toggleMobileDropdown"
      >
        <img src="../assets/mobile_menu_icon.webp" />
      </div>
      <div class="network-div">
        <button class="network-button-dsk" @click="networkModalHandler">
          <img
            v-if="isGlmr"
            src="../assets/moonbeam_logo.png"
            class="network-img-dsk"
            alt="network-logo"
          />
          <img
            v-else-if="currentChain == 'moonbase'"
            src="https://zoombies.world/images/moonbase.png"
            class="network-img-dsk"
            alt="network-logo"
          />
          <img
            v-else
            src="../assets/zetachain-icon.png"
            class="network-img-dsk"
            alt="network-logo"
          />
        </button>
      </div>
    </div>
    <div
      ref="mobileDropdown"
      :class="{
        'mobile-dropdown': true,
        'dropdown-hidden': !isMobileDropdownOpen,
      }"
    >
      <ul>
        <li @click="toggleMobileDropdown">
          <button v-b-modal.sponsor-modal class="affiliate-header-mobile">
            EARN FREE ZOOM
          </button>
        </li>
        <li @click="toggleMobileDropdown">
          <router-link
            :to="{ name: 'ShopContent', params: { chain: currentChain } }"
            class="aqua-header"
            >Shop</router-link
          >
        </li>
        <li @click="toggleMobileDropdown">
          <router-link
            :to="{ name: 'CryptContent', params: { chain: currentChain } }"
            class="aqua-header"
            >Your NFT Crypt</router-link
          >
        </li>
        <li @click="toggleMobileDropdown">
          <router-link
            :to="{ name: 'MarketContent', params: { chain: currentChain } }"
            class="lightblue-header"
            >Markets</router-link
          >
        </li>
        <li @click="toggleMobileDropdown">
          <router-link
            :to="{
              name: 'TokenContent',
              params: { chain: currentChain, token_id: '1' },
            }"
            class="lightblue-header"
            >Card Valuation</router-link
          >
        </li>
        <li @click="toggleMobileDropdown">
          <router-link
            :to="{ name: 'CardSets', params: { chain: currentChain } }"
            class="lightblue-header"
            >Card sets</router-link
          >
        </li>
        <li @click="toggleMobileDropdown">
          <router-link
            :to="{ name: 'AffiliateDashboard'}"
            class="lightblue-header"
            >Affiliates</router-link
          >
        </li>
        <li @click="toggleMobileDropdown">
          <a
            class="lightblue-header"
            href="https://www.zoombies.info/"
            target="_blank"
            >About Zoombies</a
          >
        </li>
        <li @click="toggleMobileDropdown">
          <a
            class="lightblue-header"
            href="https://zoombies.gitbook.io/zoombies/"
            target="_blank"
            >Help</a
          >
        </li>
      </ul>
    </div>
    <div class="mobile-balances">
      <div v-if="isWalletConnected" class="address-header">
        <div>
          <img
            v-if="getVipLevel == 1"
            src="../../assets/silver_vip.png"
            class="header-icon-vip"
          />
          <img
            v-else-if="getVipLevel == 2"
            src="../../assets/gold_vip.png"
            class="header-icon-vip"
          />
          <img
            v-else-if="getVipLevel == 3"
            src="../../assets/diamond_vip.png"
            class="header-icon-vip"
          />
          <img
            v-else
            src="https://zoombies.world/images/novip.png"
            class="header-icon-vip"
          />
        </div>
        <span v-b-tooltip.hover.bottom :title="getWalletAddress">
          &nbsp;{{
            getWalletAddress.substr(0, 6) + "..." + getWalletAddress.substr(38)
          }}
        </span>
      </div>
      <div v-if="isWalletConnected" class="balances-header">
        <div v-b-tooltip.hover.bottom :title="getZoomBalance">
          <img src="../../assets/zoomTokenCoin.svg" class="header-icon" />
          <span>
            {{ getZoomBalance.toLocaleString() }}
          </span>
        </div>
        <div v-b-tooltip.hover.bottom :title="getBalance">
          <img
            v-if="isGlmr"
            src="../assets/moonbeam_logo.png"
            class="header-icon"
          />
          <img v-else src="../assets/moonbase.png" class="header-icon" />
          <span
            >{{
              isGlmr
                ? getBalance.toFixed(4)
                : getBalance.toFixed(3) + `${isGlmr ? " GLMR" : " DEV"}`
            }}
          </span>
        </div>
      </div>
    </div>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==4 && Progression.storyIndex==0" target="zoombie-logo-popover" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[4].popovers[0].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==5 && Progression.storyIndex==1"  target="vip-icon-popover" placement="top" triggers="manual" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[5].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==5 && Progression.storyIndex==2"  target="vip-icon-popover" placement="top" triggers="manual" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[5].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==4 && Progression.storyIndex==3" target="zoom-icon-popover" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[4].popovers[3].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==6 && Progression.storyIndex==2" target="zoom-icon-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[6].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==6 && Progression.storyIndex==3" target="zoom-icon-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[6].popovers[3].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==7 && Progression.storyIndex==1" target="earn-zoom-popover" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[7].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover v-if="Progression.stepIndex >= 7" :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==7 && Progression.storyIndex==2" target="copy-link-popover" trigger="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[7].popovers[2].content }}
      </div>
    </b-popover>
    <!-- <b-popover target="earn-zoom-popover" :show="getURLFolder() === undefined && earnZoomHoverPopover" trigger="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[7].popovers[1].content }}
      </div>
    </b-popover> -->
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==4 && Progression.storyIndex==2" target="claim-bonus-button" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[4].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==4 && Progression.storyIndex==1" target="address-popover" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[4].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="(getURLFolder() === undefined || getURLFolder() === '' ) && Progression.stepIndex==8 && Progression.storyIndex==1" target="zoombie-logo-popover" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.body[8].popovers[1].content }}
      </div>
    </b-popover>
    <div class="spinner-container">
      <b-spinner
        class="moonbeamPrice-spinner"
        :variant="spinnerColor"
      ></b-spinner>
      <p id="moonbeamPrice-text" class="moonbeamPrice-text"> {{ moonbeamPrice }} </p>
    </div>
  </div>
</template>

<script>
import { showSuccessToast, showErrorToast } from "../../util/showToast";
import moment from "moment";
import dAppStates from "@/dAppStates";
import QrcodeVue from "qrcode.vue";
import Progress from '../Progress.js';
import storyInstructions from "../story-instructions.json";
import { Progression } from '../Progression.js'
// import VModal from 'vue-js-modal'
import {
  BModal,
  BJumbotron,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BFormInvalidFeedback,
  BAlert,
  BButton,
  BDropdownItem,
  BDropdown,
  BIconTwitter,
  BIconFacebook,
  BIconLinkedin,
  BIconWhatsapp,
  BIconTelegram,
  BIconEnvelope,
  BIconUpcScan,
  BPopover,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import { ethers } from "ethers";
import CURR_CHAIN from "../../util/constants/networks";

const baseAddress = "0x0000000000000000000000000000000000000000";

export default {
  name: "Header",
  emits: ["connect"],

  components: {
    BModal,
    BJumbotron,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormInvalidFeedback,
    BAlert,
    BButton,
    BDropdownItem,
    BDropdown,
    BIconTwitter,
    BIconFacebook,
    BIconLinkedin,
    BIconWhatsapp,
    BIconTelegram,
    BIconEnvelope,
    BIconUpcScan,
    QrcodeVue,
    BPopover,
  },
  computed: {
    async isGlmr() {
      if (window.ethereum) {
        if (
          await window.ethereum.request({method: 'eth_chainId'}) == 0x504 ||
          window.location.pathname.includes("/moonbeam", 0)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isMobileNotConnected() {
      if (!window.ethereum && window.innerWidth < 415) {
        return true;
      } else {
        return false;
      }
    },
    isDesktopNotConnected() {
      if (!window.ethereum && window.innerWidth >= 415) {
        return true;
      } else {
        return false;
      }
    },
    classObject: function () {
      //Style the link colours
      //const chainId = getChainId();
      //switch (this.chainId) {
      //    case 0x38:
      //  case 0x61:
      //      return "bsc-link";
      //    default:
      return "eth-link";
      //  }
    },
    dAppState() {
      return this.$store.state.dAppState;
    },
    isWalletConnected() {
      return this.$store.state.dAppState === dAppStates.WALLET_CONNECTED;
    },
    ZoomContribution() {
      return this.$store.state.zoomContribution;
    },
    async getSponsorRoute() {
      // let url;
      // if (window.location.pathname === "/moonbase") {
      //   url = "https://moonbase.zoombies.world";
      // } else if (process.env.NODE_ENV === "development") {
      //   url = "localhost:8080";
      // } else {
      //   url = "https://movr.zoombies.world";
      // }

      // New implementation below

      let url = "https://zoombies.world";
      let chain_id = await window.ethereum.request({method: 'eth_chainId'})
      let chain = "";

      if (chain_id == 0x507) {
        chain = "moonbase";
      } else if (chain_id == 0x504) {
        chain = "moonbeam";
      }

      return `${url}/${chain}/?sponsor=${this.getWalletAddress}`;
    },
    sponsorTitle() {
      return this.mySponsor
        ? `My Sponsor is ${this.mySponsor}`
        : "Link Your Sponsor";
    },
    getTweet() {
      return `https://twitter.com/intent/tweet?text=Click%20my%20sponsor%20link%20to%20claim%20Your%20Free%20Platinum%20Zoombies%20NFT%20Now!%0D%0A%0D%0A&hashtags=moonriver,nft,ZWorldNFT,NFTCommunity,nftcollectors,nftart,cryptoart&url=${this.getSponsorRoute}%0D%0A%0D%0A&related=CryptozNFT&via=CryptozNFT`;
    },
    getWhatsAppLink() {
      return `https://wa.me/?text=Click%20my%20sponsor%20link%20to%20claim%20Your%20Free%20Platinum%20Zoombies%20NFT%20Now!%20${this.getSponsorRoute}`;
    },
    getLinkedInLink() {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${this.getSponsorRoute}`;
    },
    getFacebookLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.getSponsorRoute}&amp;src=sdkpreparse`;
    },
    getTelegramLink() {
      return `https://telegram.me/share/url?url=${this.getSponsorRoute}&text=Click%20my%20sponsor%20link%20to%20claim%20Your%20Free%20Platinum%20Zoombies%20NFT%20Now!`;
    },
    isSponsorValid() {
      if (this.sponsorAddress === "") {
        return true;
      }

      if (
        this.sponsorAddress.toLowerCase() ===
        this.getWalletAddress.toLowerCase()
      ) {
        return false;
      }

      return ethers.utils.isAddress(this.sponsorAddress.toLowerCase());
    },
    isSameSponsor() {
      return (
        this.sponsorAddress.toLowerCase() ===
        this.getWalletAddress.toLowerCase()
      );
    },
    ...mapGetters({
      getWalletAddress: "blockChain/getWalletAddress",
      getBalance: "blockChain/getBalance",
      getVipLevel: "blockChain/getVipLevel",
      getZoomBalance: "blockChain/getZoomBalance",
      getSignedZoomContract: "blockChain/getSignedZoomContract",
      getSignedZoombiesContract: "blockChain/getSignedZoombiesContract",
    }),
  },
  created() {
    this.ProgressInstance = new Progress();

    // reset
    // this.ProgressInstance.resetProgress();

    const progress = this.ProgressInstance.getProgress();

    if (progress.hasOwnProperty('body')) {
      this.stepIndex = progress.body;
    } else {
      this.stepIndex = 1;
    }

    this.ProgressInstance.updateProgress({name: 'body', value: this.stepIndex});
    Progression.stepIndex = this.stepIndex;
  },
  data() {
    return {
      currentS: 0,
      shouldReset: false,
      spinnerColor: "success",
      moonbeamPrice: "Fetching... please wait",
      storyInstructions,
      Progression,
      popoverText: '',
      stepIndex: 1,
      qrSize: 200,
      pendingTransaction: 0,
      showSpinner: false,
      notSameSponsorError: true,
      transactionMessage: "Pending confirmation...",
      showLogin: 1,
      bonusReady: false,
      timeToBonus: 0,
      sponsorAddress: "",
      shouldShowSponsor: true,
      mySponsor: null,
      queryHasSponsor: false,
      showShareMyLink: false,
      onMainNet: false,
      isMobileDropdownOpen: false,
      currentChain: "moonbase",
      vipIconHoverPopover: false,
      earnZoomHoverPopover: false,
    };
  },
  created() {
    this.fetchPrice();
  },
  watch: {
    isWalletConnected(value) {
      if (value) {
        this.checkSponsor(this.getWalletAddress);
      }
    },
    getWalletAddress(value) {
      this.getDailyBonusTime();
      if (value) {
        this.checkSponsor(value);
        this.getZoomContributionStatus();
      }
    },
    $route(to) {
      if (!to.query.sponsor) {
        this.queryHasSponsor = false;
        this.sponsorAddress = "";
      }
    },
  },
  async mounted() {
    const t = document.getElementById('moonbeamPrice-text');
    setInterval(() => {
      if (this.shouldReset) {
        this.fetchPrice();
        this.currentS = 0;
        this.shouldReset = false;
        this.spinnerColor = 'success';
        t.classList.add('flash-text');
        setTimeout(() => {
          t.classList.remove('flash-text');
        }, 1000);
      } else {
        this.currentS += 1;
        if (this.currentS >= 6) {
          this.shouldReset = true;
          this.spinnerColor = 'danger';
        } else if (this.currentS <= 5 && this.currentS >= 4) {
          this.spinnerColor = 'warning';
        } else {
          this.spinnerColor = 'success';
        }
      }
    }, 5000);

    if (window.ethereum) {
      const chain_id = await window.ethereum.request({method: 'eth_chainId'})
      if (
        chain_id == 0x504 ||
        window.location.pathname.includes("/moonbeam", 0)
      ) {
        this.currentChain = "moonbeam";
        this.onMainNet = true;
      } else if (
        chain_id == 0x507 ||
        window.location.pathname.includes("/moonbase", 0)
      ) {
        this.currentChain = "moonbase";
        this.onMainNet = false;
      } else if (
        chain_id == 0x1B59 ||
        window.location.pathname.includes("/zeta", 0)
      ) {        
        this.currentChain = "zeta";
        this.onMainNet = false;
      }
    } else {
      this.currentChain = "moonbeam";
    }
    this.getDailyBonusTime();
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    getURLFolder() {
      return window.location.pathname.split("/")[2];
    },
    fetchPrice: async function () {
      let id;
      let coinName;
      switch (await window.ethereum.request({method: 'eth_chainId'})) {
        case "0x504":
          id = "moonbeam";
          coinName = "GLMR";
          break;
        case "0x505":
          id = "moonriver";
          coinName = "MOVR";
          break;
        case "0x1b59":
          console.log('zeta');
          id = "zetachain";
          coinName = "ZETA";
          break;
        default:
          console.log('default');
          id = "moonbeam";
          coinName = "GLMR";
          break;
      }

      try {
        const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids='+id+'&vs_currencies=USD');
        const data = await response.json();

        this.moonbeamPrice = coinName + ' price: $' + data[id].usd.toFixed(4) + ' USD';
      } catch (error) {
        console.error('Error fetching price data:', error);
      }
    },
    logoClickHandler: async function() {
      let curr_chain;
      if (window.ethereum) {
        const chain_id = await window.ethereum.request({method: 'eth_chainId'})
        if (chain_id == 0x507) {
          curr_chain = "moonbase";
        } else if (chain_id == 0x504) {
          curr_chain = "moonbeam";
        } else if (chain_id == 0x1B59) {
          curr_chain = "zeta";
        } else {
          curr_chain = "error";
        }
      } else {
        curr_chain = "moonbeam";
      }

      this.$router.push({
        name: "BodyContentChain",
        params: { chain: curr_chain },
      });
    },
    emailHandler() {
      window.open(
        `mailto:?subject=Click%20my%20sponsor%20link%20to%20claim%20Your%20Free%20Platinum%20Zoombies%20NFT%20Now!&body=Join%20now!%20${this.getSponsorRoute}`,
        "_blank"
      );
    },
    networkModalHandler: function () {
      this.$bvModal.show("network-modal");
    },
    moonbaseConnector: function () {
      this.$bvModal.hide("network-modal");
      window.location.href = "/moonbase";
    },
    moonbeamConnector: function () {
      this.$bvModal.hide("network-modal");
      window.location.href = "/moonbeam";
    },
    moonriverConnector: function () {
      this.$bvModal.hide("network-modal");
      window.location.href = "/moonriver"; 
    },
    zetaConnector: function () {
      this.$bvModal.hide("network-modal");
      window.location.href = "/zeta"; 
    },
    toggleMobileDropdown: function () {
      if (this.isMobileDropdownOpen) {
        this.isMobileDropdownOpen = false;
      } else {
        this.isMobileDropdownOpen = true;
      }
    },
    nextSponsorModalAction: function () {
      this.showShareMyLink = true;
    },
    previousSponsorModalAction: function () {
      this.showShareMyLink = false;
    },
    checkSponsor: async function (address) {
      if (this.getSignedZoombiesContract && address) {
        const sponsor = await this.getSignedZoombiesContract.sponsors(address);
        this.mySponsor = parseInt(sponsor, 16) ? sponsor : null;
        if (sponsor && sponsor !== baseAddress) {
          this.shouldShowSponsor = false;
        } else {
          if (this.$route.query.sponsor) {
            this.sponsorAddress = this.$route.query.sponsor;
            this.queryHasSponsor = true;
            this.$bvModal.show("sponsor-modal");
          }
        }
      }
    },
    linkSponsor: async function () {
      try {
        this.$store.dispatch("setIsTransactionPending", true);
        this.$store.dispatch("setIsSacrificeEvent", false);
        const result = await this.getSignedZoombiesContract.linkMySponsor(
          this.sponsorAddress
        );

        if (result) {
          this.$store.dispatch("setIsTransactionPending", false);
          await result.wait();

          showSuccessToast(this, "Sponsor linked!");
          this.shouldShowSponsor = false;
          this.mySponsor = this.sponsorAddress;
          this.nextSponsorModalAction();
        }
      } catch (error) {
        if (err.code !== 4001) {
          console.log(err);
          showErrorToast(this, "Failed to link sponsor.");
        }
        this.$store.dispatch("setIsTransactionPending", false);
      }
    },
    copySponsorLink: function () {
      const textToCopy = this.$refs.sponsor.value;
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          showSuccessToast(this, "Link Copied.");
        })
        .catch((error) => {
          console.log("Copy Failed: ", error);
        });
    },
    getDailyBonusTime: async function () {
      if (this.getSignedZoombiesContract && this.getWalletAddress) {
        const res = await this.getSignedZoombiesContract.getTimeToDailyBonus(
          this.getWalletAddress
        );

        var timeOfNextBonusInMilli = parseInt(res) * 1000;
        var now = new Date();

        if (now.getTime() >= timeOfNextBonusInMilli) {
          this.bonusReady = true; //Claim bonus state
        } else {
          this.bonusReady = false;
          this.timeToBonus = this.GetTimeString(timeOfNextBonusInMilli);
        }
      }
    },
    GetBonus: async function () {
      try {
        this.showSpinner = true;
        this.transactionMessage = "Pending confirmation...";
        this.$store.dispatch("setIsTransactionPending", true);
        this.$store.dispatch("setIsSacrificeEvent", false);

        console.log(
          "GET SIGNED ZOOMBIES CONTRACT",
          this.getSignedZoombiesContract
        );
        console.log("GET WALLET ADDRESS", this.getWalletAddress);

        const result = await this.getSignedZoombiesContract.getBonusBoosters();

        this.transactionMessage = "Broadcast to chain...";
        this.$store.dispatch("setIsTransactionConfirmed", true);

        await result.wait();
        
        this.$store.dispatch("setIsTransactionConfirmed", false);
        this.$store.dispatch("setIsTransactionPending", false);
        if (result) {
          this.getDailyBonusTime();
          this.$store.dispatch("blockChain/updateWalletBalances");
        }
      } catch (error) {
        this.transactionMessage = "Claim 1 FREE Booster!";
      } finally {
        this.showSpinner = false;
      }
    },
    GetTimeString: function (_timeStamp) {
      return moment(_timeStamp).format("MMM D, h:mm a");
    },
    getZoomContributionStatus: async function () {
      const contract = this.getSignedZoomContract;
      const zoomContribution = await contract.contributions(
        this.getWalletAddress
      );

      this.$store.state.zoomContribution = parseInt(zoomContribution);
    },
  },
};
</script>

<style scoped lang="scss">
// Dropdowns
::v-deep .modal-content {
  background-color: transparent;
}

::v-deep .modal fade show {
  padding-left: 0px;
}

.spinner-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.moonbeamPrice-spinner {
  animation-duration: 1.2s;
  width: 25px;
  height: 25px;
}

.moonbeamPrice-text {
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 0px;
  margin-left: 10px;
}

.socials-holder {
  display: flex;
  justify-content: center;
  align-items: center;

  color: #fff;
}

.new-social-icons {
  height: 36px;
  width: 36px;
}

.qr-modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  padding: 5%;

  height: 100vh;
  width: 100vw;

  background-color: #757aff;
}

.qr-code-div {
  margin-top: 20px;
}

.qr-code-text {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 800;
  font-size: 34px;
  color: #fff;
}

.modal-content {
  background-color: transparent;
}

.modal-content.booster-modal {
  background-color: transparent;
}

.jumbotron.jumbo {
  margin-bottom: 0px;
}

.platinum-jumbotron {
  background-color: transparent;
}

.button-wrapper {
  display: flex;
  margin-top: 20px;
  padding-left: 80px;
  gap: 15px 15px;

  .affiliate-button {
    height: 40px;
    margin-right: 16px;
  }

  .affiliate-button-2 {
    height: 40px;
    margin-right: 16px;
  }

  a {
    padding: 0;
  }
}
.telegram-link {
  margin-top: 5px;
  margin-right: 16px;
}

.zoombies-logo {
  float: right;
  transform: translate(-45%, -30%);
  width: 16%;
  height: auto;
}

.zoombies-image {
  float: right;
  transform: translate(0%, -86%);
  width: 32%;
  height: auto;
}

.platinum-card-image {
  float: right;
  transform: translate(128%, -80%);
}

.close-button {
  background-color: transparent;
  border-color: transparent;
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  transform: translate(125%, 25%);
}

.confirm-next-button {
  position: absolute;
  top: 625px;
  right: 70px;
  background-color: transparent;
  border-color: transparent;
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: auto;
}

.close-button-image {
  float: right;
  width: 12%;
  height: auto;
}

.confirm-next-button-image {
  float: right;
  width: 6%;
  height: auto;
}

.affiliate-modal {
  background-color: #1e162f;
  border: 3px solid;
  border-color: #00d1ff;
  border-radius: 15px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  width: fit-content;
  height: 850px;
}

.sponsor-main-title {
  padding-top: 0px;
  padding-left: 90px;
  margin-bottom: 0px;
  font-family: "Truculenta", sans-serif;
  font-size: 50px;
  font-weight: 700;
  color: #00d1ff;
}

.sponsor-description {
  margin-bottom: 0px;
  padding-left: 92px;
  padding-right: 330px;
  font-family: "Truculenta", sans-serif;
  font-size: 25px;
  font-weight: 700;
  color: #ffffff;
}

.sponsor-link-description-title {
  margin-top: 5px;
  margin-bottom: 0px;
  padding-left: 80px;
  font-family: "Truculenta", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #757aff;
}

.sponsor-link-description-title-2 {
  margin-top: 45px;
  margin-bottom: 0px;
  padding-left: 80px;
  font-family: "Truculenta", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #757aff;
}

.sponsor-link-description-text {
  margin-bottom: 45px;
  padding-right: 250px;
  color: #dc78ff;
  font-size: 28px;
  display: block;
  clear: both;
}

.sponsor-link-description {
  padding-left: 80px;
  padding-right: 330px;
  font-family: "Truculenta", sans-serif;
  font-size: 25px;
  font-weight: 700;
  color: #ffffff;
}

.sponsor-link-text-title {
  margin-top: 5px;
  margin-bottom: 0px;
  padding-left: 80px;
  font-family: "Truculenta", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #757aff;
}

.sponsor-link-text {
  margin-bottom: 0px;
  padding-left: 80px;
  padding-right: 350px;
  font-family: "Truculenta", sans-serif;
  font-size: 25px;
  font-weight: 700;
  color: #ffffff;
}

.sponsor-address-input {
  padding-left: 80px;
  padding-right: 400px;
}

.mobile-dropdown {
  position: absolute;
  top: 70px;
  z-index: 2;
  width: 190px;
  display: none;
  height: 330px;
  background-color: #1e162f;
  border-width: 0px 4px 4px 4px;
  border-style: solid;
  border-color: #00d1ff;
  box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
  border-radius: 0px 0px 25px 25px;
  overflow: hidden;
  text-align: center;
  transition: all 0.5s ease;
  padding: 20px;
  padding-top: 40px;

  font-size: 20px;
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  .mobile-wallet-info {
    display: flex;
    color: orange;
    font-size: 14px;
    margin: 10px 0;

    .header-icon {
      width: 18px;
      height: 18px;
    }
  }

  .affiliate-btn {
    background: none;
    border: none;
    padding: 0;
  }

  ul {
    margin-bottom: 0;
  }

  li {
    padding: 2px 0;
    display: block;

    &:hover {
      transform: scale(1.05);
    }

    a {
      text-decoration: none;
    }
  }

  .brain {
    width: 35px;
    padding: 10px 0;
  }
}

.dropdown-hidden {
  height: 0;
  display: hidden;
  border: none;
  padding-top: 0;
  padding-bottom: 0;
}

.desktop-connect-btn {
  margin: 5px;
  width: 200px;
  margin-right: 0;
}

.hamburger-menu {
  display: none;
}

.app-header {
  padding: 16px 0 0 0;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 90%;
  max-width: 1500px;
  margin: 0 auto;
}

.wallet-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #d48b15;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-right: 32px;
}

.header-icon {
  height: 20px;
  margin-right: 5px;
}

.header-icon-vip {
  height: 40px;
}

#wallet-balance {
  margin-left: 16px;
  color: #90ee90;
}

.app-menu-bar {
  background-image: url("../assets/menu_bar.png");
  background-size: 100% 140%;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 240px;

  z-index: 3;
  width: 100%;
}

.zoombie-logo {
  width: 150px;
  padding-bottom: 20px;
  padding-left: 10px;
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    transform: translateY(-50%) scale(1.1);
    cursor: pointer;
  }
}

.app-menu-bar-items {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding: 0;
  position: relative;

  li {
    display: inline-block;
    margin-right: 12px;

    &:hover {
      transform: scale(1.1);
    }

    a {
      text-decoration: none;
    }
  }
}

.network-img {
  border-radius: 9999px;
  width: 100%;
}

.network-button {
  border-radius: 9999px;
  width: 50px;
}

.network-button-dsk {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 100px;
  padding: 0;
}

.network-img-dsk {
  border-radius: 9999px;
  width: 100%;
}

.header-item {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  text-transform: uppercase;
}

.header-item-drop {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;

  color: #b2f1ff;

  display: inline-block;
  width: 100%;
}

.balances-header {
  display: flex;
  flex-direction: column;
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;

  color: #b2f1ff;
}

.address-header {
  display: flex;
  align-items: center;

  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  text-align: center;

  color: #ffffff;
}

.network-div {
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-53%, -50%);
  z-index: 4;

  width: 45px;
  height: 45px;
  position: absolute;

  background: #ffffff;
  border: 3px solid #00d1ff;
  border-radius: 100px;
}

.mobile-bonus {
  display: none;
}

.mobile-balances {
  display: none;
}

@media screen and (max-width: 1250px) {
  .balances-header {
    font-size: 14px;
    line-height: 24px;
  }

  .address-header {
    font-size: 14px;
    line-height: 24px;
  }

  .close-button {
    transform: translate(0%, 25%);
    margin-right: 10px;
  }

  .affiliate-modal {
    height: auto;
    padding-bottom: 20px;
  }

  .sponsor-main-title {
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 20px;
  }

  .zoombies-logo {
    transform: translate(-20%, -120%);
    width: 10%;
    height: auto;
  }

  .sponsor-description {
    padding-left: 30px;
    padding-right: 30px;
  }

  .sponsor-link-description-title {
    padding-left: 20px;
  }

  .sponsor-link-description {
    padding-left: 20px;
    padding-right: 20px;
  }

  .sponsor-address-input {
    padding-left: 20px;
  }

  .sponsor-link-text-title {
    padding-left: 20px;
  }

  .sponsor-link-text {
    padding-left: 20px;
  }

  .button-wrapper {
    padding-left: 20px;
  }

  .zoombies-image {
    transform: translate(-20%, -110%);
  }
}

@media screen and (max-width: 1075px) {
  .app-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "Oswald", sans-serif;

    ul {
      padding-left: 0;

      li {
        margin: 0;
        text-align: left;
      }
    }
  }

  .mobile-bonus {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    margin-bottom: 20px;
    min-width: 100px;

    .bonusClass {
      color: #ff19b1;
      font-family: "Truculenta";
      font-style: normal;
      font-weight: 800;
      font-size: 14px;
      line-height: 14px;
    }

    .bonusClassNo {
      font-family: "Truculenta";
      font-style: normal;
      font-weight: 800;
      font-size: 12px;
      line-height: 14px;

      display: flex;
      flex-direction: column;
      max-width: 150px;
    }

    .time-to-bonus {
      font-size: 12px;
      line-height: 12px;
    }

    .spinner-text-style {
      display: flex;
      font-family: "Truculenta";
      font-style: normal;
      font-weight: 800;
      font-size: 10px;
      line-height: 10px;
      color: #fff;
    }
  }

  .mobile-connect-btn {
    padding: 3px 10px;
  }

  .mobile-balances {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .mobile-dropdown {
    display: flex;
    flex-direction: column;
  }

  .app-menu-bar {
    height: 80px;
    justify-content: flex-end;
  }

  .zoombie-logo {
    width: 80px;
  }

  .hamburger-menu {
    display: flex;
    align-items: center;
    height: 100%;

    img {
      width: 40px;
      height: 30px;
      margin-right: 15px;
      margin-bottom: 20px;
    }
  }

  .desktop-connect-btn,
  .desktop-bonus,
  .app-menu-bar-items,
  .wallet-info {
    display: none;
  }
}

@media screen and (max-width: 992px) {
  .sponsor-address-input {
    padding-right: 20px;
  }

  .sponsor-link-text {
    padding-right: 150px;
  }

  .zoombies-image {
    transform: translate(-20%, -200%);
  }

  .button-wrapper {
    display: grid;
    grid-template-columns: auto auto auto auto;
  }
}

@media screen and (max-width: 800px) {
  .zoombies-logo {
    float: right;
    transform: translate(-10%, 10%);
    width: 18%;
    height: auto;
  }

  .zoombies-image {
    transform: translate(-15%, -150%);
    width: 32%;
    height: auto;
  }

  .network-div {
    width: 40px;
    height: 40px;
  }

  .platinum-card-image {
    float: right;
    transform: translate(0%, 0%);
  }

  .close-button {
    padding-left: 90px;
    transform: translate(0%, 0%);
  }

  .affiliate-modal {
    background-color: #1e162f;
    border: 3px solid;
    border-color: #00d1ff;
    border-radius: 15px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: fit-content;
  }

  .sponsor-main-title {
    padding-top: 0px;
    padding-left: 12px;
    margin-bottom: 0px;
    font-family: "Truculenta", sans-serif;
    font-size: 25px;
    font-weight: 700;
    color: #00d1ff;
  }

  .sponsor-description {
    margin-bottom: 0px;
    padding-left: 14px;
    padding-right: 10px;
    font-family: "Truculenta", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
  }

  .sponsor-link-description-title {
    margin-top: 5px;
    margin-bottom: 0px;
    padding-left: 4px;
    font-family: "Truculenta", sans-serif;
    font-weight: 700;
    font-size: 25px;
    color: #757aff;
  }

  .sponsor-link-description-title-2 {
    margin-top: 45px;
    margin-bottom: 0px;
    padding-left: 4px;
    font-family: "Truculenta", sans-serif;
    font-weight: 700;
    font-size: 25px;
    color: #757aff;
  }

  .sponsor-link-description-text {
    margin-bottom: 45px;
    padding-right: 0px;
    color: #dc78ff;
    font-size: 22px;
    display: block;
    clear: both;
  }

  .sponsor-link-description {
    padding-left: 6px;
    padding-right: 10px;
    font-family: "Truculenta", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
  }

  .sponsor-link-text-title {
    margin-top: 5px;
    margin-bottom: 0px;
    padding-left: 8px;
    font-family: "Truculenta", sans-serif;
    font-weight: 700;
    font-size: 25px;
    color: #757aff;
  }

  .sponsor-link-text {
    margin-bottom: 0px;
    padding-left: 8px;
    padding-right: 180px;
    font-family: "Truculenta", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
  }

  .sponsor-address-input {
    padding-left: 8px;
    padding-right: 10px;
  }

  .affiliate-button {
    margin-top: 10px;
    width: 100%;
    height: 15px;
  }

  .affiliate-button-2 {
    margin-top: 10px;
    width: 60%;
    height: 45px;
  }

  .button-wrapper {
    margin-top: 10px;
    padding-left: 8px;
  }

  .telegram-link {
    margin-left: 55px;
    margin-top: 10px;
  }

  .app-menu-bar {
    background-image: url("../assets/menu_bar.png");
  }

  .hamburger-menu {
    img {
      width: 30px;
      height: 25px;
    }
  }
}

.desktop-bonus {
  max-width: 210px;

  .bonusClass {
    color: #ff19b1;
    font-family: "Truculenta";
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 30px;
  }

  .bonusClassNo {
    max-width: 150px;
  }
}

.header-right-container {
  margin-right: 32px;
  position: absolute;
  right: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30vw;
  gap: auto;
}

.affiliate-header {
  color: #ff19b1;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.affiliate-header-mobile {
  color: #ff19b1;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  font-size: 22px;
  font-weight: 700;
}

.aqua-header {
  color: #05e1ff;
}

.lightblue-header {
  color: #b2f1ff;
}

/*******************************
OLD CSS
**********************************/

.prev-next-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 18px;

  button {
    color: #f0b90b;
  }
}

.platinum-card {
  margin-top: 0px;
  display: flex;
  justify-content: center;
}

.platinum-card-wrapper {
  position: relative;
  img {
    width: 300px;

    @media screen and (max-width: 400px) {
      width: 200px;
    }
  }

  .question-mark {
    font-size: 7rem;
    font-weight: bold;
    color: white;
    position: absolute;
    top: 17%;
    left: 43%;

    @media screen and (max-width: 400px) {
      top: 10%;
      left: 40%;
    }
  }
}

#wallet-nav:empty {
  height: 0;
}

#wallet-nav {
  display: flex;
  flex: 1;
  grid-row: 2;
  justify-content: center;
  height: 40px;
  align-items: center;
}

#wallet-id {
  color: #d48b15;
  display: flex;
  justify-content: center;
  margin-right: 20px;
}

#wallet-balance {
  display: flex;
  color: #90ee90;
}

.platinum-jumbotron {
  margin-top: 0 !important;
}

.bonusClass {
  animation: shake 3.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  margin-right: 0.8em;
  padding: 1px;
  border: 1px solid transparent;

  color: #ff19b1;
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;

  text-align: center;
}

@media screen and (max-width: 600px) {
  .nav-item {
    height: 40px;
    display: flex;
    align-items: center;
  }

  .bonusClass {
    margin-right: 0;
  }

  #shop {
    position: relative;
    margin-top: 10px;
  }

  #shop:before {
    content: "";
    height: 1px;
    background: gray;
    position: absolute;
    top: -5px;
    left: 10px;
    right: 10px;
  }

  .tooltip-1 {
    top: 0 !important;
  }

  .tooltip-2 {
    top: 0 !important;
  }

  .header-icon-vip {
    height: 34px;
    margin-right: 7px;
  }

  .sponsor-link-text {
    padding-right: 120px;
  }

  .zoombies-image {
    transform: translate(-5%, -220%);
  }

  .button-wrapper {
    margin-top: 20px;
  }

  .affiliate-button {
    font-size: 12px;
  }

  .moonbeamPrice-spinner {
    width: 14px;
    height: 14px;
  }

  .moonbeamPrice-text {
    font-size: 14px;
  }
}

#cryptoz-logo {
  margin-right: 3rem;
}

.router-link-active {
  text-decoration: underline;
}

.mm-header {
  color: #fff;
  text-align: right;
  margin-right: 10px;
  width: 23em;
}

#nav-collapse {
  overflow-x: auto;
}

.logo-nav {
  margin-right: 0.5em;
  width: 2em;
}

li {
  margin-right: 1.2em;
}

a {
  padding: 2px;
}

/* BINANCE color #F0B90B */
.bsc-link {
  color: #f0b90b;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.bonusClass:hover {
  animation: none;
  color: white;
  margin-right: 0.8em;
  padding: 1px;
}

.bonusClassNo {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  color: #ff19b1;
}

.bonusClassLogIn {
  color: #ffff00;
  margin-right: 3.2em;
}
.wallet-balance {
  color: lightgreen;
  margin: 0 4em 0 1em;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.eth-link,
.bsc-link {
  white-space: nowrap;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
.spinner {
  width: 2em;
}
.spinner-text-style {
  color: #fff;
}

.jumbo {
  margin-top: 0 !important;
  padding: 10px 10px;
  margin-bottom: 50px;
}

.lead {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  word-break: break-all;
}

.sponsor-warning {
  font-weight: bold;
  color: #dc3545;
}

.czxp-logo {
  width: 25px;
  height: 25px;
  vertical-align: middle;
}

.time-to-bonus {
  white-space: nowrap;
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
  text-align: center;

  color: #ffffff;
}

.badge-icon {
  max-width: 2rem;
  animation: glow 3s infinite alternate;
}

@keyframes glow {
  from {
    filter: drop-shadow(1px 1px 0px #ffffff);
  }
  to {
    filter: drop-shadow(1px 1px 4px #ffffff);
  }
}

.events-drawer-button {
  margin-right: 8px;
}

::v-deep .modal-content {
  border: none;
}

.network-modal {
  background-color: #1e162f;
  border: 4px solid;
  border-color: #00d1ff;
  border-radius: 15px;
  width: 500px;
  height: 280px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  padding: 10% 5%;
}

.network-close-button {
  position: absolute;
  top: 30px;
  right: 0px;
  padding: 1px 15px;

  color: #ffffff;
  background-color: #dc3545;
  border: 3px solid;
  border-color: #dc3545;
  border-radius: 10px;
  cursor: pointer;

  font-family: "Truculenta";
  font-style: normal;

  &:hover {
    background-color: #901e29;
    border-color: #901e29;
  }
}

.network-modal-title {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 800;
  font-size: 40px;
  color: #00d1ff;

  text-align: center;
}

.network-switch-btn-container {
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 16px;
  grid-column-gap: 8px;
  column-gap: 8px;
  grid-row-gap: 16px;
  row-gap: 16px;
}

.network-switch-btn-container :hover {
  color: #1e162f;
  background-color: #ffffff;
  font-weight: 800;
}

.network-links {
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: "Truculenta";
  font-style: normal;
  font-weight: 500;
  text-decoration: none;
  color: white;

  background: none;
  border: 1px solid white;
  border-radius: 5px;

  margin-right: 16px;
  padding: 6px;
}

.network-links p {
  font-size: 20px;
  margin: 0;
}
.network-icons {
  width: 30px;
  border-radius: 9999px;
  margin-right: 8px;
}
</style>

<style lang="scss">
.dropdown-container {
  .btn-secondary {
    color: #00d1ff;
    border: none;
    background: transparent;
    padding: 0 10px;
    font-size: 25px;
  }
  ul {
    z-index: 5;
    border-radius: 0px 0px 25px 25px;
    border-width: 0px 2px 2px 2px;
    border-style: solid;
    border-color: #00d1ff;
    box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
    background: linear-gradient(0deg, #111324, #111324), #1e162f;

    li {
      width: 100%;

      :hover {
        background-color: #00d1ff;
        transform: none !important;
      }
    }
  }
}
#qr-modal {
  padding: 0 !important;

  .modal-dialog {
    min-height: 100vh !important;
    min-width: 100vw !important;
    margin: 0;

    .modal-content {
      height: 100vh !important;
      width: 100vw !important;
      border: none;

      .modal-body {
        padding: 0 !important;
      }
    }
  }
}

.flash-text {
  animation: flash 1s ease;
}

@keyframes flash {
  0% {
    color: white;
    scale: 1;
  }
  50% {
    color: #5cb85c;
    scale: 1.05;
  }
  100% {
    color: white;
    scale: 1;
  }
}
</style>
